angular.module('impactx').constant("scrollableConfig", {
    template    : '<div class="{nanoClass}"><div ix-scroll-detection="onScroll(event, scrollTop)" class="{contentClass}" ng-transclude></div></div>',
    bottomMargin: 40
});